<template>
  <filter-parent
    :title="texts.location"
    :start-open="true"
    :icon="'location-pin'"
  >
    <city-select
      :default="selectedLocation"
      :clearable="true"
      :placeholder="texts.startTyping"
      @on-select="updateLocation"
    />
  </filter-parent>
</template>

<script lang="ts">
import CitySelect from 'Components/CitySelect.vue';
import { useCityTermLocalStorage } from 'Main/composables/useCityTermLocalStorage';
import { mapMutations, mapState } from 'vuex';
import FilterParent from '../common/FilterParent.vue';

export default {
  components: {
    FilterParent,
    CitySelect,
  },

  setup() {
    const {
      cityTerm,
      saveCityTermToLocalStorage,
      getCityTermFromLocalStorage,
    } = useCityTermLocalStorage();
    return {
      cityTerm,
      saveCityTermToLocalStorage,
      getCityTermFromLocalStorage,
    };
  },

  data() {
    return {
      selectedLocation: null,
      texts: window.theme_vars.counselorGridTexts,
    };
  },

  computed: {
    ...mapState('counselorGrid', ['filteredLocation']),
    ...mapState('cities', ['cities']),
  },

  watch: {
    filteredLocation: {
      immediate: true,
      handler(location) {
        if (!location) {
          if (this.selectedLocation) {
            this.selectedLocation = null;
          }
          return;
        }

        if (this.selectedLocation?.label === location) {
          return;
        }

        const match = this.cities?.find(
          (city) => city.label === location
        );
        this.selectedLocation = match ?? { label: location };
      },
    },
    cities() {
      if (!this.filteredLocation || this.selectedLocation?.choice) {
        return;
      }
      const match = this.cities?.find(
        (city) => city.label === this.filteredLocation
      );
      if (match) {
        this.selectedLocation = match;
      }
    },
  },

  methods: {
    ...mapMutations('counselorGrid', ['setFilteredLocation']),

    updateLocation(location: Record<string, string>): void {
      this.selectedLocation = location;
      this.setFilteredLocation(location ? location.label : null);
      this.updateWebsiteLocation(location);
    },

    updateWebsiteLocation(location: Record<string, string>): void {
      if (!location) {
        return;
      }

      this.$store.dispatch(
        'cities/getCityLink',
        location ? location.choice : ''
      );

      this.cityTerm = location
        ? {
            id: location.choice,
            name: location.label,
          }
        : null;

      this.saveCityTermToLocalStorage();
    },
  },
};
</script>
